import { requisitar } from "./http";

export interface PedidoDeLogin {
  /** E-mail **ou** nome de usuário. O servidor não pergunta qual dos dois. */
  identificador: string;
  senha: string;
  manterConectado: boolean;
}

export interface RespostaDeLogin {
  /** Sessão parcial: falta o segundo fator. Só `/api/auth/mfa` responde. */
  segundoFatorPendente: boolean;
  usuarioId: string;
  nome: string;
}

export interface Perfil {
  id: string;
  nome: string;
  nomeDeUsuario: string | null;
  email: string;
  segundoFatorAtivo: boolean;
}

export interface Versao {
  versao: string;
  commit: string;
  dataBuild: string;
  /** desenvolvimento · homologacao · operacao_assistida · producao */
  ambiente: string;
}

export const autenticacao = {
  entrar: (pedido: PedidoDeLogin) =>
    requisitar<RespostaDeLogin>("/auth/login", { metodo: "POST", corpo: pedido }),

  confirmarSegundoFator: (codigo: string) =>
    requisitar<RespostaDeLogin>("/auth/mfa", { metodo: "POST", corpo: { codigo } }),

  sair: () => requisitar<void>("/auth/logout", { metodo: "POST" }),

  /**
   * Quem está logado.
   *
   * **É assim que se responde "estou autenticado?"** — não por variável
   * local. O cookie é invisível ao JavaScript; a única fonte da verdade é
   * o servidor. Um `401` aqui significa "não está".
   */
  eu: () => requisitar<Perfil>("/auth/eu"),
};

export const sistema = {
  versao: () => requisitar<Versao>("/versao"),
};
